import Config from '@/config.js'

var authFunctions = {
    login: function (username, password) {
        var richiesta = new Request(Config.apiurl + '/login', {
          method: 'post',
          headers: new Headers({
            'Content-Type': 'application/json',
            Authorization: Config.apikey,
          }),
          body: JSON.stringify({
            username: username,
            password: password,
            package_version: process.env.PACKAGE_VERSION || '0',
          }),
        })
        // ritorna una promise
        var risposta = fetch(richiesta)
        return risposta
    },
    keepToken: function (refreshToken) {
      var richiesta = new Request(Config.apiurl + '/secure/renewAccessToken', {
          method: 'get',
          headers: new Headers({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + refreshToken,
          }),
        })
        // ritorna una promise
        var risposta = fetch(richiesta)
        return risposta
    },
}
export default authFunctions
